import React from 'react';
import { blogPosts } from '@/lib/blogData';

export const RelatedPosts: React.FC<{ currentSlug: string }> = ({ currentSlug }) => {
    const related = blogPosts.filter(p => p.slug !== currentSlug).slice(0, 3);

    return (
        <div className="bg-muted/30 py-20 border-t border-border">
            <div className="container px-4 max-w-6xl mx-auto">
                <h3 className="text-2xl font-bold mb-8">Read Next</h3>
                <div className="grid md:grid-cols-3 gap-8">
                    {related.map(p => (
                        <div key={p.slug} className="group cursor-pointer">
                            <div className="aspect-video rounded-xl bg-card border border-border mb-4 overflow-hidden">
                                {p.imageUrl ? <img src={p.imageUrl} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" alt={p.title}/> : <div className="w-full h-full bg-primary/5"></div>}
                            </div>
                            <div className="text-xs font-medium text-primary mb-2">{p.category}</div>
                            <h4 className="text-lg font-bold leading-snug group-hover:text-primary transition-colors">{p.title}</h4>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
